import intl from "components/i18n/ReactIntlWrapper";
import { TextField, IconButton, Box } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

const TimeOffSearchBar = ({ queryString, setQueryString }) => {
  return (
    <Box display="flex" width="100%" minWidth="200px">
      <TextField
        fullWidth
        variant="outlined"
        size="small"
        placeholder={intl.get("timeOffSearchBar.placeholder")}
        value={queryString}
        onChange={(e) => setQueryString(e.target.value)}
      />
      {queryString && (
        <IconButton
          onClick={() => setQueryString("")}
          size="small"
          sx={{ ml: 1 }}
        >
          <CancelIcon className="iconButton" />
        </IconButton>
      )}
    </Box>
  );
};

export default TimeOffSearchBar;
